// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d47f6d88","455":"1f011b6f","977":"83b9b49c"}[chunkId] + ".chunk.js";
};